// extracted by mini-css-extract-plugin
export default {"root":"_2Dz0e5rJv-rBboAvzrr3Vs","headerContainer":"_23BvFnTbkKSYCqaMjRkf1u","image":"_2Ba2BKrjJCzc6uae28jsF6","headerGradient":"_3IAZ3Br45OU3clGigluWTD"};